import { render } from "./SuppluOrderView.vue?vue&type=template&id=7085a59a&scoped=true"
import script from "./SuppluOrderView.vue?vue&type=script&lang=js"
export * from "./SuppluOrderView.vue?vue&type=script&lang=js"

import "./SuppluOrderView.vue?vue&type=style&index=0&id=7085a59a&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7085a59a"]])

export default __exports__